let sizes = [
  { name: 'mobile', invokable: width => width < 767 },
  { name: 'tablet', invokable: width => width >= 767 },
];

export default (name, fn) => () => {
  let size = sizes.find(size => size.name === name);
  if (size.invokable(window.innerWidth)) fn();
};
